/**
 * ./exercise6/Exercise6Summary.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import confettiSvg from "../components/icons/Confetti.svg";
import homeIcon from "../components/icons/Home.svg";
import { updateUserProgress } from '../utility';

const Exercise6Summary = () => {
  const [showConfetti, setShowConfetti] = useState(true);
  const location = useLocation();
  const currentTime = location.state?.currentTime || 0;
  const highestTime = location.state?.highestTime || 0;
  const navigate = useNavigate();
  const duration = location.state?.duration || 1; // Get duration from navigation state

  // Automatically hide the confetti after animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 4000); // Match this to the animation duration
    
    return () => clearTimeout(timer);
  }, []);

  const handleNextSection = () => {
    navigate("/exercise7"); // Replace with the actual next section path
  };

  return (
    <div className="exercise-summary-container">
      {showConfetti && (
        <div className="confetti-container">
          <img
            src={confettiSvg}
            alt="Confetti"
            className="confetti-animation"
          />
        </div>
      )}

      <h1>Congratulations on completing the duration</h1>
      <p>
        You have expanded your peripheral vision and improved your ability to
        focus. Practically, this exercise will not only be useful in the
        following exercises, but also help you read quicker and within a wider
        scope by utilizing your peripheral vision.
      </p>
      <p>You may move onto the next exercise.</p>

      <div className="bottom-buttons">
        <button className="home-button" onClick={() => navigate("/")}>
          <img src={homeIcon} alt="Home" className="home-icon" />
        </button>
        {/* <button className="next-button" onClick={handleNextSection}>
          Next Section
        </button> */}
      </div>
    </div>
  );
};

export default Exercise6Summary;
